import { SubItem } from "../SubItemTypes";

export const items: SubItem[] = [
  {
    heading: "Movie Lover",
    terms: "01/2026 - 03/2026",
    description:
      "Movie Lover application — a platform for analyzing your IMDB lists with AI-powered movie and TV show recommendations.",
    stack: [
      "TypeScript",
      "NestJS",
      "React",
      "Tailwind CSS",
      "PostgreSQL",
      "Redis",
      "Gemini API",
      "Google Cloud Storage",
    ],
    links: [
      {
        link: "https://github.com/marharita08/movie-lover-api",
        name: "Backend GitHub link",
      },
      {
        link: "https://github.com/marharita08/movie-lover",
        name: "Frontend GitHub link",
      },
      {
        link: "https://movie-lover-five.vercel.app",
        name: "App link",
      },
    ],
  },
  {
    heading: "Awesome Store",
    terms: "26/03/2025 - 18/04/2025",
    description:
      "Awesome Store is a small e-commerce application built with modern full-stack technologies, designed to provide a simple and responsive shopping experience.",
    stack: [
      "TypeScript",
      "Expo",
      "React Native",
      "React Hook Form",
      "Zustand",
      "NestJS",
      "Prisma ORM",
    ],
    links: [
      {
        link: "https://github.com/marharita08/awesome-store",
        name: "GitHub link",
      },
    ],
  },
  {
    heading: "BeBalance",
    terms: "16/08/2024 – 28/09/2024",
    description:
      "Track your work-life balance and improve the specific areas of your life with AI recommendations.",
    stack: [
      "TypeScript",
      "React",
      "Fastify",
      "PostgreSQL",
      "Redux Toolkit",
      "React Hook Form",
      "Objection ORM",
      "Knex",
    ],
    links: [
      {
        link: "https://github.com/BinaryStudioAcademy/bsa-2024-bebalance",
        name: "GitHub link",
      },
      {
        link: "https://www.youtube.com/watch?v=lm5-kMisMfQ&t=1s",
        name: "App demo link",
      },
    ],
  },
];
